import { useMemo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import SedigovIcon from '@/components/common/Icons/SedigovIcon';

interface INewAdminFooterProps {
  isLoginFooter?: boolean;
}

const NewAdminFooter = ({ isLoginFooter }: INewAdminFooterProps) => {
  const userPerms = useMemo(() => {
    const raw = localStorage.getItem('userauth');
    if (!raw) return [];

    const userAuth = JSON.parse(raw);
    const perms: string[] = userAuth?.permissions ?? [];

    return perms;
  }, []);

  if (isLoginFooter)
    return (
      <section className="bg-blueLight px-12 py-1.5">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="flex flex-row items-center space-x-2.5">
            <SedigovIcon className="w-[105px]" />
            <div className="h-[27px] w-[1px] bg-silver" />
            <Image src="/google_cloud_partner.png" alt="cs3_logo.co" width={87} height={30} />
          </div>

          <div className="flex flex-row items-center space-x-5 text-sm font-medium text-tundora">
            <span className="text-sm text-dimGray">Powered by</span>
            <Image src="/cs3_logo.png" alt="cs3_logo.co" width={230} height={40} />
          </div>
        </div>
      </section>
    );

  return (
    <section className="bg-blueLight px-12 py-3">
      <div className="flex flex-col items-center justify-between md:flex-row">
        <div className="flex flex-row items-center space-x-2.5">
          <Image src="/new_logo_gov_co.png" alt="new_gov.co" width={85} height={28} />
          <div className="h-[27px] w-[1px] bg-marine" />
          <p className="text-lg font-semibold text-marine">Portal funcionario</p>
        </div>

        <div className="flex flex-row items-center space-x-5 text-sm font-medium text-tundora">
          {userPerms.some((p) => p.startsWith('page-config')) && (
            <Link href={'/admin/home/page-config'}>Configuración de la página principal</Link>
          )}
          {userPerms.some((p) => p.startsWith('micro-sites')) && (
            <Link href={'/admin/home/micro-sites'}>Micro-Sitios</Link>
          )}
          {userPerms.some((p) => p.startsWith('param')) && (
            <Link href={'/admin/home/parametrization'}>Parametrización</Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewAdminFooter;
